/**
 * Shared activity feed row — dashboard widget + Activity center.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Video, ListChecks, CalendarClock, UserPlus, Eye, FileText, AlertTriangle,
  CheckCircle2, Sparkles, Share2 as ShareNetwork, Mail, Bell, Users, Clock,
  Link as LinkIcon, ClipboardCheck, Star, MessageSquare, Share2,
} from 'lucide-react';

const ICONS = {
  Video, ListChecks, CalendarClock, UserPlus, Eye, FileText, AlertTriangle,
  CheckCircle2, Sparkles, ShareNetwork, Mail, Bell, Users, Clock,
  Link: LinkIcon, ClipboardCheck, Star, MessageSquare, Share2,
};

export function activityHref(item) {
  if (item.candidate_id) {
    return item.evaluation_id
      ? `/portal/candidates/${item.candidate_id}?eval=${encodeURIComponent(item.evaluation_id)}`
      : `/portal/candidates/${item.candidate_id}`;
  }
  if (item.kind) return '/portal/notifications';
  return '/portal/activity';
}

export function ActivityFeedRow({ item, fmtTs, className = '', testId }) {
  const Icon = ICONS[item.icon] || FileText;
  const href = activityHref(item);
  const description = item.description || item.action || '';
  const candidateName = item.candidate_name || '';
  const detail = item.detail || '';

  return (
    <Link
      to={href}
      className={`flex items-start gap-3 rounded-lg p-2 transition-colors hover:bg-accent ${className}`}
      data-testid={testId}
    >
      <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-secondary text-foreground/70">
        <Icon className="h-4 w-4" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm leading-snug">
          {item.actor && item.actor !== 'System' && (
            <>
              <span className="font-semibold">{item.actor}</span>{' '}
            </>
          )}
          <span className={item.actor && item.actor !== 'System' ? 'text-muted-foreground' : ''}>
            {description}
          </span>
          {candidateName && (
            <>
              {' '}
              <span className="text-muted-foreground">for</span>{' '}
              <span className="font-medium">{candidateName}</span>
            </>
          )}
        </p>
        {detail && (
          <p className="mt-0.5 text-xs text-muted-foreground line-clamp-2">{detail}</p>
        )}
        {fmtTs && item.timestamp && (
          <p className="mt-0.5 text-xs text-muted-foreground">{fmtTs(item.timestamp)}</p>
        )}
      </div>
    </Link>
  );
}

export { ICONS as ACTIVITY_ICONS };
